// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__b2tx1","inputWrap":"styles_inputWrap__1rAHD","input":"styles_input__385Nj"};